module.exports = __webpack_public_path__ + "static/media/homepage-section-6-phone-1.5f55e458.png";